import { render, staticRenderFns } from "./TimetableSidebar.vue?vue&type=template&id=70ab060c"
import script from "./TimetableSidebar.vue?vue&type=script&lang=js"
export * from "./TimetableSidebar.vue?vue&type=script&lang=js"
import style0 from "./TimetableSidebar.vue?vue&type=style&index=0&id=70ab060c&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports